<template>
  <div class="container" ref="bookContainer">
    <!-- <div class="background-container"></div> -->
    <draggable
      class="module-container"
      v-model="bookContentData"
      :animation="200"
      :group="'description'"
      :disabled="mode !== 'edit'"
      :ghostClass="'ghost'"
      :handle="'.draggable-handle'"
      @start="drag = true"
      @end="drag = false"
      @change="handleSortModule"
    >
      <component
        v-for="(module, index) in bookContentData"
        :key="module.key"
        :is="module.type"
        :id="`i_book_module_${index + 1}_${module.key}`"
        :class="`i_book_module_${index + 1}`"
        :mode="mode"
        :moduleData="module.data"
        @onCopy="data => handleCopyModule(index, module.type, data)"
        @onDelete="handleDeleteModule(index)"
        @onChange="data => handleContentDataChange(index, module.key, module.type, data)"
      />
    </draggable>

    <!-- 添加模块 -->
    <module-add v-if="mode === 'edit'" @addModule="handleAddModule"></module-add>
  </div>
</template>

<script>
import draggable from "vuedraggable";
// components
import ModuleAdd from "./components/ModuleAdd";
import ModuleBox from "./components/ModuleBox";
// moudles
import TabInfo from "./modules/TabInfo";
import ZsTabInfo from "./modules/ZsTabInfo";
import CharacterProfile from "./modules/CharacterProfile";
import CharacterInfo from "./modules/CharacterInfo";
import FightInfo from "./modules/FightInfo";
import SkillInfo from "./modules/SkillInfo";
import WeaponInfo from "./modules/WeaponInfo";
import UpgradeInfo from "./modules/UpgradeInfo";
import MaterialInfo from "./modules/MaterialInfo";
import AudioInfo from "./modules/AudioInfo";
import RelationInfo from "./modules/RelationInfo";
// constans
import { MODULE_DEF_DATA } from "./constans";

export default {
  name: "BookContent",
  props: {
    mode: {
      type: String,
      default: "edit"
    },
    contentData: {
      type: Array,
      default: () => []
    }
  },
  components: {
    draggable,
    ModuleAdd,
    ModuleBox,
    TabInfo,
    ZsTabInfo,
    CharacterProfile,
    CharacterInfo,
    FightInfo,
    SkillInfo,
    WeaponInfo,
    UpgradeInfo,
    MaterialInfo,
    AudioInfo,
    RelationInfo
  },
  data() {
    return {
      bookContentData: this.contentData ? this.contentData.map(it => ({ key: Math.random().toString(16), ...it })) : [],
      drag: false
    };
  },
  watch: {
    contentData: {
      handler(val) {
        this.bookContentData = val ? val.map(it => ({ key: Math.random().toString(16), ...it })) : [];
      },
      deep: true
    }
  },
  mounted() {
    if (this.$route) {
      const query = this.$route.query;
      // 适配参数?anchor_id=i_book_module_2&hide_other=1&active_tab=1
      // 锚点定位
      if (query.anchor_id) {
        const element = document.querySelector("." + query.anchor_id);
        if (element) {
          // 隐藏其他模块
          if (query.hide_other == 1) {
            const childs = element.parentNode.parentNode.childNodes;
            Array.prototype.forEach.call(childs, node => {
              if (element.parentNode !== node) {
                node.style.display = "none";
              }
            });
          }
          const elementPosition = element.getBoundingClientRect();
          const offsetPosition = elementPosition.top + window.pageYOffset - 0;
          window.scrollTo({
            top: offsetPosition
            // behavior: 'smooth',
          });
        }
      }
    }

    // 预览图片
    const imgs = this.$refs.bookContainer.querySelectorAll(".preview-image");
    Array.prototype.forEach.call(imgs, (img, index) => {
      img.addEventListener("click", () => {
        this.handleImgPreview(imgs, index);
      });
    });

    // 监听粘贴事件
    window.addEventListener("paste", this.pasteModuledata);

    // this.getObjectId(this.bookContentData);
  },
  beforeDestroy() {
    window.removeEventListener("paste", this.pasteModuledata);
  },
  methods: {
    // 粘贴模块数据
    pasteModuledata(event) {
      const paste = event.clipboardData.getData("text") || "";
      // console.log(typeof paste);
      // __illustrated_book_module_data__:
      if (paste.startsWith("__illustrated_book_module_data__:")) {
        // console.log("1");
        // eslint-disable-next-line
        const dataStr = paste.replace(/^\_\_illustrated\_book\_module\_data\_\_\:/g, "");
        const data = JSON.parse(dataStr || "");
        // console.log(data)
        this.bookContentData.push(data);
        // console.log(this.bookContentData);
        this.$emit("contentChange", this.bookContentData);
      }
    },
    // 模块排序
    handleSortModule() {
      this.$emit("contentChange", this.bookContentData);
    },
    // 数据变更
    handleContentDataChange(dataIndex, key, type, data) {
      this.bookContentData.splice(dataIndex, 1, {
        key,
        type,
        data
      });
      // console.log(dataIndex, type);
      // console.log(this.bookContentData);
      this.$emit("contentChange", this.bookContentData);
    },
    // 模块添加
    handleAddModule(type) {
      const defaultData = JSON.parse(JSON.stringify(MODULE_DEF_DATA[type]));
      this.bookContentData.push(defaultData);
      this.$emit("contentChange", this.bookContentData);
    },
    // 模块删除
    handleDeleteModule(index) {
      this.bookContentData.splice(index, 1);
      this.$emit("contentChange", this.bookContentData);
    },
    // 图片预览
    handleImgPreview(imgs, index) {
      const urls = Array.prototype.map.call(imgs, img => img.src);
      this.$imgViewShow(urls, index);
    },
    // 模块复制
    handleCopyModule(dataIndex, type, data) {
      this.bookContentData.splice(dataIndex + 1, 0, {
        type,
        data
      });
      this.$emit("contentChange", this.bookContentData);
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  position: relative;
  width: 100%;
  height: auto;
  padding: 20px;
  // background-image: url("../../../assets/images/illustrated-book-bg.svg");
  background: #f7f7f7;
  border-radius: 8px;
  background-size: 100% auto;
  background-repeat: repeat-y;
  transform: translate3d(0, 0, 0);
  .background-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    max-height: 254px;
    background: linear-gradient(180deg, #ececec 0%, #f7f7f7 100%);
    border-radius: 8px 8px 0px 0px;
  }
}
// .module-container {
//   width: 976px;
//   background: rgba(255, 255, 255, 0.24);
//   border-radius: 8px;
//   padding: 18px 19px;
// }
</style>
